@switch (formStep) {
  @case (FormSteps.invites) {
    <form class="modal-body" novalidate [formGroup]="form" (ngSubmit)="formStep = FormSteps.group">
      <p class="centermodal__title">{{ 'settings.inviteUsers' | translate }}</p>
      <p class="centermodal__description text-left">{{ 'settings.allUsersWillShareOrgPlanAndSetPermissions' | translate }}</p>

      <ng-container formGroupName="member">
        <app-email-input
          class="mb-3"
          [label]="'settings.userEmails' | translate"
          (emailsChange)="onEmailsChange($event)"
          (hasErrorChange)="onChildErrorChange($event)"
          [initialEmails]="memberEmails"
        ></app-email-input>
      </ng-container>

      <div class="centermodal__button-group">
        <button type="button" class="btn-L btn-filled-cancel" (click)="modal.dismiss()">{{ 'button.cancel' | translate }}</button>
        <button type="submit" class="btn-L btn-filled" [disabled]="isLoading || form.get('member.email').invalid || memberEmails.length == 0 || childHasError">
          {{ 'button.forward' | translate }}
        </button>
      </div>
    </form>
  }

  @case (FormSteps.group) {
    <form class="modal-body" novalidate [formGroup]="form" (ngSubmit)="formStep = FormSteps.permissions; setSelectedGroupPermissions()">
      <div class="centermodal__title">{{ 'settings.selectUserGroup' | translate }}</div>
      <p class="centermodal__description text-left">{{ 'settings.youCanAssignGroupToUsers' | translate }}</p>

      <ng-container [ngTemplateOutlet]="membersTagList" [ngTemplateOutletContext]="{ $implicit: getEmails() }"></ng-container>

      <ng-container formGroupName="member">
        <div class="centermodal__group">
          <div [appFormControlWrap]="form.get('member.group_id')">
            <app-select placeholder="{{ 'settings.group' | translate }}" formControlName="group_id" [options]="groups" required [optionsRequest]="organizationGroups.bind(this)"></app-select>
          </div>
        </div>
      </ng-container>

      <div class="centermodal__button-group mt-4">
        <button type="button" class="btn-L btn-filled-cancel" (click)="formStep = FormSteps.invites">{{ 'button.back' | translate }}</button>
        <button type="submit" class="btn-L btn-filled" [disabled]="isLoading || form.invalid">{{ 'button.forward' | translate }}</button>
      </div>
    </form>
  }

  @case (FormSteps.permissions) {
    <form class="modal-body" novalidate [formGroup]="form" (ngSubmit)="invite()">
      <div class="centermodal__title">{{ 'settings.setPermissions' | translate }}</div>

      <ng-container [ngTemplateOutlet]="membersTagList" [ngTemplateOutletContext]="{ $implicit: getEmails() }"></ng-container>

      @if (groupOverwritesPermissions) {
        <div class="alertMessage size-S default">
          <i class="far fa-circle-exclamation"></i>
          <div>
            {{ 'settings.permissionsOverwritten' | translate }}
            <span>{{ 'settings.permissionsOverwrittenDesc' | translate }}</span>
          </div>
        </div>
      }

      <app-organization-permissions-form [form]="$any(form.get('member.permissions'))"></app-organization-permissions-form>

      <div class="centermodal__button-group mt-3">
        <button type="button" class="btn-L btn-filled-cancel" (click)="formStep = FormSteps.group">{{ 'button.back' | translate }}</button>
        <button type="submit" class="btn-L btn-filled" [disabled]="isLoading">{{ 'button.sendInvitations' | translate }}</button>
      </div>
    </form>
  }
}

<ng-template let-emails #membersTagList>
  <div class="centermodal__tag-list">
    <div class="centermodal__tag-title">{{ 'settings.' + (emails.length > 1 ? 'forNewMembers' : 'forNewMember') | translate: { emailLength: emails.length } }}</div>
    <div class="centermodal__tag" *ngFor="let email of emails">{{ email }}</div>
  </div>
</ng-template>
